module.exports = __webpack_public_path__ + "static/FCUB_map-a99bed6919a55322cc9f4c450ff10e81.jpg";